module.exports = __webpack_public_path__ + "static/media/educazione-finanziaria_protezione.09a514df.png";